<template>
  <div>
    <PersonalDataForm ref="personalDataForm" v-if="currentState === 'personalDataForm'" />
    <ValueForm ref="valueForm" :formData="this.forms.valueForm" v-if="currentState === 'valueForm'" />
    <PaymentForm ref="paymentForm" :paymentsForms="this.forms.paymentsForms " v-if="currentState === 'paymentForm'" />
    <br>
    <a href="https://www.cancer.org.br/politica-de-privacidade/">Conheça nossa política de privacidade.</a>
    <div class="new-form-controls" v-if="showNextButton">
      <div class="new-form-control" v-if="currentState !== 'personalDataForm' ">
        <button
          @click="back"
          class="new-form-button new-form-button-default"
          v-if="!(this.currentState === 'valueForm' || this.currentState === 'valueForm')"
        > Voltar
        </button>
      </div>
      <div class="new-form-control" >
        <button
          @click="next"
          class="new-form-button new-form-button-primary"
        > {{ this.currentState === 'paymentForm' ? 'Enviar' : 'Próximo' }}
        </button>
      </div>
    </div>
    <div class="new-form-loading" v-if="this.loading"></div>
  </div>
</template>

<script>
import PaymentForm from './PaymentForm/index';
import ValueForm from './ValueForm/ValueForm';
import PersonalDataForm from './PersonalDataForm/PersonalDataForm';
import { setupAxios } from '../setupAxios';
import { hasTokenExpired } from '../localStorageManager';
import { querySearch } from '../../../helpers'

export default {
  name: 'DoeAgoraForm',
  components: { ValueForm, PaymentForm, PersonalDataForm },
  data: () => ({
    donator: '',
    currentState: 'personalDataForm',
    loading: false,
    showNextButton: true,
    forms: {
      valueForm: {
        amount: '',
        recurring: '',
        source: '',
      },
      paymentsForms: {
        debit: {
          bank: 'itau',
          agency: '',
          bank_account: '',
          payment_day: ''
        },
        credit: {
          card_number: '',
          titular_name: '',
          card_month: '',
          card_year: ''
        },
        boleto: {
          city: '',
          state: ''
        }
      }
    }
  }),
  mounted: async function () {
    const source = querySearch("source");

    if (source) {
      this.forms.valueForm.source = source;
    }
    
    const token = !hasTokenExpired() ? localStorage.getItem('token') : undefined;
    if (token) {
      await this.getUserData(token);
    }
  },
  methods: {
    async next () {
      if (!(await this.canGoNext())) return;

      if (this.currentState === 'personalDataForm') {
        this.currentState = 'valueForm';
      } else if (this.currentState === 'valueForm') {
        this.currentState = 'paymentForm';
      } else if (this.currentState === 'paymentForm') {
        this.submit();
      }
    },
    back () {
      if (this.currentState === 'valueForm') {
        this.currentState = 'personalDataForm';
      } else if (this.currentState === 'paymentForm') {
        this.currentState = 'valueForm';
      }
    },

    async canGoNext () {
      return this.$refs[this.currentState].validForm();
    },
    getFormData () {
      return {
        ...this.forms.valueForm,
        ...this.forms.paymentsForms.debit,
        ...this.forms.paymentsForms.credit,
        ...this.forms.paymentsForms.boleto,
        ...this.$refs.paymentForm.form,
        donator: this.donator
      };
    },
    // @todo: mover para form do tipo escolhido?
    submit: async function () {
      this.setLoading(true);
      const token = localStorage.getItem('token');
      const data = { ...this.getFormData() };
      const result = await this.getAxios().post(
        '/api/v2/donation',
        data,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      this.setLoading(false);

      if (result) {
        alert('Doação registrada!');
        if (result.data.hasOwnProperty('boleto')) {
          alert('Iremos redirecionar voce para o seu boleto! Permita ao navegador abrir popups!');
          window.open(result.data.boleto, '_new');
        }
      }
    },
    getCurrentValidationObserver () {
      return this.$refs[this.currentState].getValidationObserver();
    },
    getAxios () {
      return setupAxios(this.getCurrentValidationObserver());
    },
    async getUserData (token) {
      const headers = {
        headers: {
          Authorization: 'Bearer ' + token
        }
      };

      const result = await this.getAxios().get('/api/get-current-user', headers);

      if (result.status === 200) {
        this.currentState = 'valueForm';
        this.donator = result.data.user.id;
      }
    },
    setLoading (isLoading) {
      this.loading = isLoading;
    },
    shouldShowNextButton (should = true) {
      this.showNextButton = should;
    }
  }

};
</script>

